import request from '@/utils/request'


// 查询音频举报记录列表
export function listReport(query) {
  return request({
    url: '/music/report/list',
    method: 'get',
    params: query
  })
}

// 查询音频举报记录分页
export function pageReport(query) {
  return request({
    url: '/music/report/page',
    method: 'get',
    params: query
  })
}

// 查询音频举报记录详细
export function getReport(data) {
  return request({
    url: '/music/report/detail',
    method: 'get',
    params: data
  })
}

// 新增音频举报记录
export function addReport(data) {
  return request({
    url: '/music/report/add',
    method: 'post',
    data: data
  })
}

// 修改音频举报记录
export function updateReport(data) {
  return request({
    url: '/music/report/edit',
    method: 'post',
    data: data
  })
}

// 删除音频举报记录
export function delReport(data) {
  return request({
    url: '/music/report/delete',
    method: 'post',
    data: data
  })
}
